import { api } from './api';
import type {
  AuthSessionResponse,
  CreateInvitationResponse,
  InvitationToken,
  InvitationValidationResponse,
  InvitationsResponse,
  MessageResponse,
  UpdateUserRoleResponse,
  User,
} from '@exhale/contracts';

class UserService {
  async getAllUsers(): Promise<User[]> {
    const response = await api.get<User[]>('/users');
    return response || [];
  }

  async updateUserRole(userId: number, role: 'admin' | 'reviewer'): Promise<User> {
    const response = await api.patch<UpdateUserRoleResponse>(`/users/${userId}/role`, { role });
    return response.user;
  }

  async createInvitation(email: string, role: 'admin' | 'reviewer' = 'reviewer'): Promise<CreateInvitationResponse> {
    const response = await api.post<CreateInvitationResponse>('/users/invite', { email, role });
    return response;
  }

  async getInvitations(): Promise<InvitationToken[]> {
    const response = await api.get<InvitationsResponse>('/users/invitations');
    return response.invitations || [];
  }

  async resendInvitation(token: string): Promise<MessageResponse> {
    return api.post<MessageResponse>(`/users/invitations/${token}/resend`);
  }

  async revokeInvitation(token: string): Promise<void> {
    await api.delete<MessageResponse>(`/users/invitations/${token}`);
  }

  async deleteUser(userId: number): Promise<void> {
    await api.delete<MessageResponse>(`/users/${userId}`);
  }

  async validateInvitation(token: string): Promise<InvitationValidationResponse> {
    const response = await api.get<InvitationValidationResponse>(`/auth/invite/${token}`);
    return response;
  }

  async registerWithInvitation(
    token: string,
    password: string,
    firstName: string,
    lastName: string
  ): Promise<AuthSessionResponse> {
    return api.post<AuthSessionResponse>(`/auth/invite/${token}/register`, {
      password,
      firstName,
      lastName,
    });
  }
}

export const userService = new UserService();
